import type { ReportType } from '../../reports-page-types/report-type';
import { REPORT_TYPES } from '../../reports-page-types/report-type';
import { REPORTS_WITH_JOBS_TABLE } from '../../reports-page-consts/suggested-reports-section-const';
import { SuggestedReport } from './suggested-report-types';

const ORDERED_REPORT_TYPES = [
  REPORT_TYPES.COMMITMENT_USAGE,
  REPORT_TYPES.CONTRACTS,
  REPORT_TYPES.RECURRING_REVENUE,
  REPORT_TYPES.NRR_GRR,
  REPORT_TYPES.UNCHARGED_USAGE,
  REPORT_TYPES.PRODUCTS_USAGE,
  REPORT_TYPES.CUSTOMER_REVENUE,
  REPORT_TYPES.MONTHLY_CLOSURE,
  REPORT_TYPES.AR_AGING,
  REPORT_TYPES.ANONYMOUS_CUSTOMERS,
  REPORT_TYPES.FAILED_INVOICE_DELIVERIES,
  REPORT_TYPES.USAGE,
  REPORT_TYPES.USAGE_REPORT_V2,
  REPORT_TYPES.COMMITMENT_VS_USAGE,
  REPORT_TYPES.JOURNAL_ENTRIES,
  REPORT_TYPES.UNMETERED_EVENTS,
  REPORT_TYPES.CUSTOMERS,
  REPORT_TYPES.CUSTOMER_MASTER,
  REPORT_TYPES.UPCOMING_INVOICES,
];

export function getSuggestedReportsConfig() {
  return ORDERED_REPORT_TYPES.map<SuggestedReport>((reportType, reportTypeIndex) => ({
    id: reportType,
    title: getReportTitle(reportType),
    href: getReportHref(reportType),
    priority: reportTypeIndex,
  }));
}

export function getReportHref(reportType: ReportType): string {
  if (REPORTS_WITH_JOBS_TABLE.has(reportType)) {
    return `/reports?reportType=${encodeURIComponent(reportType)}`;
  }

  switch (reportType) {
    case REPORT_TYPES.CONTRACTS:
      return '/reports/contracts';
    case REPORT_TYPES.RECURRING_REVENUE:
      return '/reports/recurring-revenue';
    case REPORT_TYPES.NRR_GRR:
      return '/reports/nrr-grr';
    case REPORT_TYPES.CUSTOMERS:
      return '/reports/customers';
    case REPORT_TYPES.CUSTOMER_MASTER:
      return '/reports/customer-master';
    case REPORT_TYPES.ANONYMOUS_CUSTOMERS:
      return '/reports/anonymous-customers';
    case REPORT_TYPES.MONTHLY_CLOSURE:
      return '/reports/monthly-closure';
    case REPORT_TYPES.FAILED_INVOICE_DELIVERIES:
      return '/reports/failed-invoice-deliveries';
    case REPORT_TYPES.CUSTOMER_REVENUE:
      return '/reports/customer-revenue';
    case REPORT_TYPES.USAGE_REPORT_V2:
      return '/reports/usage-report-v2';
    case REPORT_TYPES.UPCOMING_INVOICES:
      return '/reports/billing-forecast';
    case REPORT_TYPES.COMMITMENT_VS_USAGE:
      return '/reports/commitment-vs-usage';
    case REPORT_TYPES.JOURNAL_ENTRIES:
      return '/reports/journal-entries';
    case REPORT_TYPES.UNMETERED_EVENTS:
      return '/reports/unmetered-events';
    default:
      return `/reports?reportType=${encodeURIComponent(reportType)}`;
  }
}

function getReportTitle(reportType: ReportType): string {
  switch (reportType) {
    case REPORT_TYPES.FAILED_INVOICE_DELIVERIES:
      return 'Email Exception Report';
    default:
      return reportType;
  }
}
